const template = document.createElement("template");
template.innerHTML = `
  <style>
  i {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
  }
  i.none-checked::before {
    content: "\\f0c8";
    color: white;
  }
  i.all-checked::before {
    content: "\\f14a";
    color: white;
  }
  i.some-checked::before {
    content: "\\f146";
    color: white;
  }
  i.some-unchecked::before {
    content: "\\f146";
    color: white;
  }
  </style>
  <i class="none-checked" data-checkbox-all='Y' data-column-property=''></i>
`;

export class HeaderSelectCheckElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  private $checkbox: HTMLElement;

  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
    this.$checkbox = this._shadowRoot.querySelector("i");
    this.$checkbox.setAttribute("data-column-property", this.property);
    this.$checkbox.addEventListener("click", () => {
      const event = new CustomEvent("tableCheckHeaderClicked", {
        bubbles: true,
        detail: {
          property: this.property,
        },
      });
      this.dispatchEvent(event);
    });
  }

  get property() {
    return this.getAttribute("property");
  }

  set status(status: string) {
    this.$checkbox.classList.remove("none-checked", "some-checked", "all-checked", "some-unchecked");
    this.$checkbox.classList.add(status);
  }

  public setHidden(hidden: boolean) {
    this.hidden = hidden;
  }

  set hiddenWithCriteria(disabled: boolean) {
    if (this.getAttribute("canSelectByCriteria") !== "true") {
      this.hidden = disabled;
    }
  }

}

export function initCheckHeaderWebComponent() {
  window.customElements.define("table-check-header", HeaderSelectCheckElement);
}
